import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import {SearchBarService} from '@cdk/components/search-bar/search-bar.service';
import {filter, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    selector: 'custom-search-bar-judicial',
    template: `
        <div class="campo" (click)="selecionaCampoJudicial(this.campoNumero, this.nomeCampoNumero, 'judicial')" [ngClass]="{'selected': searchField === this.campoNumero}">
            <span>{{this.nomeCampoNumero}}</span>
            <mat-icon class="text-base text-primary w-[24px] h-[24px] min-w-[14px] min-h-[14px]" style="font-size: 24px !important;" *ngIf="searchField === this.campoNumero">check</mat-icon>
        </div>
        <div class="campo" (click)="selecionaCampoJudicial(this.campoAlternativo, this.nomeCampoAlternativo, 'judicial')" [ngClass]="{'selected': searchField === this.campoAlternativo}">
            <span>{{this.nomeCampoAlternativo}}</span>
            <mat-icon class="text-base text-primary w-[24px] h-[24px] min-w-[14px] min-h-[14px]" style="font-size: 24px !important;" *ngIf="searchField === this.campoAlternativo">check</mat-icon>
        </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent implements OnInit, OnDestroy {
    campoNumero = 'vinculacoesProcessosJudiciaisProcessos.processoJudicial.numero';
    nomeCampoNumero = 'CNJ'; // ALTERADO PELA PGE
    campoAlternativo = 'vinculacoesProcessosJudiciaisProcessos.processoJudicial.numeroAlternativo';
    nomeCampoAlternativo = 'Outro Número Judicial'; // ALTERADO PELA PGE

    searchField: string;
    searchFieldName: string;

    // Private
    private _unsubscribeAll: Subject<any> = new Subject();

    /**
     *
     * @param _changeDetectorRef
     * @param _searchBarService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _searchBarService: SearchBarService
    ) {}

    ngOnInit(): void {
        // Subscribe to searchBar field changes
        this._searchBarService.searchField.pipe(
            takeUntil(this._unsubscribeAll),
            filter(campo => !!campo)
        ).subscribe(
            (campo) => {
                this.searchField = campo;
                this._changeDetectorRef.detectChanges();
            }
        );

        // Subscribe to searchBar field changes
        this._searchBarService.searchFieldName.pipe(
            takeUntil(this._unsubscribeAll),
            filter(campo => !!campo)
        ).subscribe(
            (campo) => {
                this.searchFieldName = campo;
                this._changeDetectorRef.detectChanges();
            }
        );
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    selecionaCampoJudicial(campo: string, nome: string, module: string): void {
        this._searchBarService.setSearchField(campo);
        this._searchBarService.setSearchFieldName(nome);
        this._searchBarService.setModule(module);

        // ALTERADO PELA PGE-RS: adicionado. 
        const input = document.querySelector('.input-field') as HTMLInputElement;
        if (input) {    
            setTimeout(() => {
                input.focus();
                input.value = '';
            }, 150);  
        }  
    }
}
